import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'

const setKitWant = async ({ want, kit }) => {
	try {
		const { kitId } = kit
		const uid = getCurrentUid()
		const ref = firestore.collection('kits').doc(kitId).collection('wanters').doc(uid)
		if (want) {
			await ref.set({ uid, kitId, createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
		} else {
			await ref.delete()
		}
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}

export default setKitWant



// WEBPACK FOOTER //
// ./src/dataservices/setKitWant.js